export default __webpack_public_path__ + "static/media/pearopolis.33e2c505.svg";